<form [formGroup]="formDomestic" *ngIf="locale === LocaleEnum.Domestic">
    <fieldset>
        <input
            [tabindex]="0"
            pInputText
            placeholder="Postal Code"
            formControlName="PostalCode"
        />
        <p-dropdown
            [tabindex]="1"
            [virtualScroll]="true"
            itemSize="32"
            placeholder="State"
            [options]="states"
            formControlName="State"
            [filter]="true"
            [editable]="false"
            [required]="true"
            appendTo="body"
            optionLabel="State"
            dataKey="State"
            (onChange)="SelectState.next($event.value)"
        >
        </p-dropdown>
        <p-dropdown
            [tabindex]="2"
            [virtualScroll]="true"
            itemSize="32"
            placeholder="City"
            [options]="cities"
            formControlName="City"
            [filter]="true"
            [editable]="false"
            [required]="true"
            appendTo="body"
            optionLabel="City"
            dataKey="City"
            (onChange)="SelectCity.next($event.value)"
        ></p-dropdown>
    </fieldset>
    <div class="p-dialog-footer" style="display: flex; flex-direction: row-reverse;">
        <button
            pButton
            label="Save"
            title="Save"
            icon="pi pi-check"
            (click)="Close.next(formDomestic.value)"
            class="p-button-text p-button-success"
            [disabled]="formDomestic.invalid"
            default
        ></button>
        <button
            pButton
            label="Cancel"
            title="Cancel"
            icon="pi pi-times"
            (click)="Close.next()"
            class="p-button-text p-button-danger"
        ></button>
    </div>
</form>
<form [formGroup]="formForeign" *ngIf="locale === LocaleEnum.Foreign">
    <fieldset>
        <p-dropdown
            [tabindex]="0"
            [virtualScroll]="true"
            itemSize="32"
            [placeholder]="CountryArea"
            [options]="countries"
            formControlName="CountryArea"
            [filter]="true"
            [editable]="false"
            [required]="true"
            appendTo="body"
            optionLabel="CountryArea"
            dataKey="CountryArea"
            (onChange)="SelectCountry.next($event.value)"
        >
        </p-dropdown>
        <p-dropdown
            [tabindex]="1"
            placeholder="Location"
            [options]="locations"
            formControlName="Location"
            [required]="true"
            [filter]="true"
            [editable]="false"
            appendTo="body"
            optionLabel="Destination"
            dataKey="Destination"
            [virtualScroll]="true"
            itemSize="32"
            (onChange)="SelectLocation.next($event.value)"
        ></p-dropdown>
    </fieldset>
    <div class="p-dialog-footer" style="display: flex; flex-direction: row-reverse;">
        <button
            pButton
            label="Save"
            title="Save"
            icon="pi pi-check"
            (click)="Close.next(formForeign.value)"
            class="p-button-text p-button-success"
            [disabled]="formForeign.invalid"
            default
        ></button>
        <button
            pButton
            label="Cancel"
            title="Cancel"
            icon="pi pi-times"
            (click)="Close.next()"
            class="p-button-text p-button-danger"
        ></button>
    </div>
</form>
<form [formGroup]="formOCONUS" *ngIf="locale === LocaleEnum.OCONUS">
    <fieldset>
        <p-dropdown
            [tabindex]="0"
            [virtualScroll]="true"
            itemSize="32"
            [placeholder]="CountryArea"
            [options]="areas"
            formControlName="CountryArea"
            [filter]="true"
            [editable]="false"
            [required]="true"
            appendTo="body"
            optionLabel="CountryArea"
            dataKey="CountryArea"
            (onChange)="SelectCountry.next($event.value)"
        >
        </p-dropdown>
        <p-dropdown
            [tabindex]="1"
            #fromCity
            placeholder="Location"
            [options]="locations"
            formControlName="Location"
            [required]="true"
            [filter]="true"
            [editable]="false"
            appendTo="body"
            optionLabel="Destination"
            dataKey="Destination"
            [virtualScroll]="true"
            itemSize="32"
            (onChange)="SelectLocation.next($event.value)"
        ></p-dropdown>
    </fieldset>
    <div class="p-dialog-footer" style="display: flex; flex-direction: row-reverse;">
        <button
            pButton
            label="Save"
            title="Save"
            icon="pi pi-check"
            (click)="Close.next(formOCONUS.value)"
            class="p-button-text p-button-success"
            [disabled]="formOCONUS.invalid"
        ></button>
        <button
            pButton
            label="Cancel"
            title="Cancel"
            icon="pi pi-times"
            (click)="Close.next()"
            class="p-button-text p-button-danger"
        ></button>
    </div>
</form>
